import { Link } from 'react-router-dom'
import style from './breadcrumbs.module.css'

/**
 * Breadcrumbs component
 * @param {Object} props
 * @param {Array} props.items - Array of breadcrumb items with path and label
 * @param {boolean} props.absolute - Whether to position absolutely
 */
const Breadcrumbs = ({ items = [], absolute = false }) => {
  if (!items || items.length === 0) return null

  return (
    <div className={`${style.breadcrumbs} ${absolute ? style.absolute : ''}`}>
      <div className={style.breadcrumbs_container}>
        <nav aria-label="breadcrumb">
          <ol className={style.breadcrumbs_list}>
            {items.map((item, index) => (
              <li key={index} className={style.breadcrumbs_item}>
                {index > 0 && (
                  <span className={style.breadcrumbs_separator}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M9.24219 4L4.99955 8.24264L9.24219 12.4853"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        transform="rotate(180 8 8)"
                      />
                    </svg>
                  </span>
                )}
                {index === items.length - 1 ? (
                  <span className={style.breadcrumbs_current}>
                    {item.label}
                  </span>
                ) : (
                  <Link to={item.path} className={style.breadcrumbs_link}>
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </div>
  )
}

export default Breadcrumbs
